<template>
  <div class="row">
    <div class="col">
      <p>Use the following facility to manage the Copilot applications by partner location.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="input-group mb-3">
        <span class="input-group-text">Filter by:</span>
        <select id="channel" v-model="filterId" class="form-control">
          <option v-for="item of firms" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col">
      <button class="btn btn-primary" @click="addApp">Add</button>
    </div>
  </div>
  <div class="row">
    <div class="col custom-table">
      <z-table
        v-model="currentApps"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :columns="tableColumnsName"
        :loading="loading.firmApps"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <a href="#" @click="editApp(props.row)">edit</a>
          </td>
          <th scope="row" class="custom-column-60">{{ props.row.firmApp }}</th>
          <td>{{ props.row.firmName }}</td>
          <td>{{ props.row.appName }}</td>
          <td>{{ props.row.appNumber }}</td>
          <td class="text-center">{{ formatBMS(props.row.isBms) }}</td>
          <td class="custom-column-60">
            <a href="#" @click="removeApp(props.row)">remove</a>
          </td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
    <div class="col"></div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
  <dialog-app v-model="actionApp" @closing="closeModal" @saved="savedApp" />
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { appsStore } from '@/stores/apps'
import { locationStore } from '@/stores/location'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogApp from '@/components/configuration/apps/DialogApp.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
export default {
  name: 'FirmApps',
  components: {
    ConfirmDelete,
    DialogApp,
    ZTable
  },
  data() {
    return {
      isHeaderFixed: true,
      isSave: false,
      confirmDeleteTitle: 'Confirm Location/App Removal',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion:
        'Note: this will remove the selected Location/App from your main App list.  Are you sure you wish to DELETE this Location/App?',
      actionDelete: null,
      actionApp: null,
      filterId: null
    }
  },
  mounted() {
    this.isSave = false
  },
  computed: {
    ...mapState(appsStore, ['apps', 'loading', 'firmApps', 'firmApp']),
    ...mapState(locationStore, ['partners']),
    tableColumnsName() {
      let columns = [
        {
          field: 'firmApp',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'firmApp',
          label: 'Id',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        { field: 'firmName', label: 'Location', sortable: false },
        { field: 'appName', label: 'App Name', sortable: false },
        { field: 'appNumber', label: 'App Id', sortable: false },
        {
          field: 'isBms',
          label: 'BMS',
          sortable: false,
          class: 'custom-column-60 text-center'
        },
        {
          field: 'firmApp',
          label: '',
          sortable: false,
          class: 'custom-column-80'
        }
      ]
      return columns
    },
    isLoading() {
      return this.loading.apps
    },
    firms() {
      let _firms = []
      _firms.push({
        id: 0,
        name: 'All'
      })
      if (this.partners) {
        this.partners.forEach((partner) => {
          _firms.push(partner)
        })
      }
      return _firms
    },
    currentApps() {
      let _apps = []
      if (this.firmApps) {
        _apps = this.firmApps.filter((x) => !x.isRemove)
        if (this.filterId) {
          _apps = _apps.filter((x) => x.firm === this.filterId)
        }
      }
      return _apps
    },
    isChecked() {
      let _is = false
      if (this.firmApps) {
        let found = this.firmApps.filter((x) => x.isChecked)
        if (found) {
          if (found.length > 0) {
            _is = true
          }
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions(appsStore, ['setFirm', 'setApp', 'getFirmApps', 'deleteApp']),
    closeModal() {
      this.isSave = false
      this.actionDelete = null
      this.actionApp = null
    },
    changed() {
      this.isSave = true
    },
    formatBMS(value) {
      let _is = null
      if (value) {
        _is = 'Y'
      }
      return _is
    },
    async savedApp() {
      this.isSave = false
      this.closeModal()
      await this.getFirmApps(2)
    },
    addApp() {
      this.setApp(null)
      this.actionApp = {
        isAdd: true
      }
    },
    editApp(app) {
      console.log('Editing App', app)
      this.setApp(app)
      this.actionApp = {
        isAdd: false
      }
    },
    removeApp(app) {
      this.setApp(app)
      this.confirmDeleteQuestion = `This will remove the selected Location/App from the App list.<br/><br/>Are you sure you wish to DELETE "${app.firmName}/${app.appName}"?`
      this.actionDelete = true
    },
    async performDeletion() {
      await this.deleteApp()
      this.isSave = false
      this.closeModal()
      await this.getFirmApps(2)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-table {
  max-height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
